import { render, staticRenderFns } from "./OrganismBuildingLabels.vue?vue&type=template&id=89b8e1ce&scoped=true&"
import script from "./OrganismBuildingLabels.vue?vue&type=script&lang=js&"
export * from "./OrganismBuildingLabels.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBuildingLabels.vue?vue&type=style&index=0&id=89b8e1ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b8e1ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculeBuildingLabel: require('/app/components/molecules/project/MoleculeBuildingLabel.vue').default})
